import React from 'react';
import { Info } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface SubscriptionSavingsMetricsProps {
  totalSaved: number;
  remainingEligible: number;
  migratedCount: number;
  eligibleCount: number;
}

export const SubscriptionSavingsMetrics: React.FC<SubscriptionSavingsMetricsProps> = ({
  totalSaved,
  remainingEligible,
  migratedCount,
  eligibleCount,
}) => {
  const formatedTotalSaved = totalSaved.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const formatedRemainingEligible = remainingEligible.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return (
 
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Total Saved Card */}
      <div className="border-2 border-green-300 rounded-xl bg-white dark:bg-background p-5 ">
        <div className="space-y-1">
          <div className="flex items-center gap-1.5">
            <h3 className="text-sm font-medium text-muted-foreground">Total Saved</h3>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Info className="h-3.5 w-3.5 text-muted-foreground cursor-help" />
                </TooltipTrigger>
                <TooltipContent className="max-w-xs">
                  <p>Total amount of Stripe fees avoided from subscriptions that have already been updated.</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
          <div className="flex items-baseline gap-2">
            <span className="text-3xl font-bold text-green-600 dark:text-green-400">
              ${formatedTotalSaved}
            </span>
            <span className="text-sm text-muted-foreground">per year</span>
          </div>
          <p className="text-xs text-muted-foreground">
            From {migratedCount} updated subscription{migratedCount !== 1 ? 's' : ''}
          </p>
        </div>
      </div>

      {/* Fees on Active Subscriptions Card */}
      <div className="border-2 border-red-300 rounded-xl bg-white dark:bg-background p-5 ">
        <div className="space-y-1">
          <div className="flex items-center gap-1.5">
            <h3 className="text-sm font-medium text-muted-foreground">Fees on Active Subscriptions</h3>
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Info className="h-3.5 w-3.5 text-muted-foreground cursor-help" />
                </TooltipTrigger>
                <TooltipContent className="max-w-xs">
                  <p>Estimated Stripe fees still being paid on active card subscriptions that haven't been migrated yet.</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
          <div className="flex items-baseline gap-2">
            <span className="text-3xl font-bold text-red-500 dark:text-red-400">
              ${formatedRemainingEligible}
            </span>
            <span className="text-sm text-muted-foreground">per year</span>
          </div>
          <p className="text-xs text-muted-foreground">
            From {eligibleCount} active card subscription{eligibleCount !== 1 ? 's' : ''}
          </p>
        </div>
      </div>
    </div>
  );
};